<script>
/* COMPOSANTS */
import MultiSelect from 'primevue/multiselect';
import AkDropdown from '@components/v2/input/AkDropdown.vue';
import AkInputText from '@components/v2/input/AkInputText.vue';
import AkButtonFooterSidebarFilter from '@components/v2/general/AkButtonFooterSidebarFilter.vue';
import AkCalendar from '@components/v2/input/AkCalendar.vue';

/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';
import utilsMixin from '@mixins/utilsMixin';
import sidebarMixin from '@/mixins/sidebarMixin';
import accommodationTypeConst from '@mixins/const/accommodationTypeConst';
import residenceTypeConst from '@mixins/const/residenceTypeConst';
import ownerTypesConst from '@mixins/const/ownerTypesConst';

/* SERVICES */
import companyMixin from '@mixins/companyMixin';
import commercialService from '@services/commercialService';
import mandatOfferConst from '../../../mixins/const/mandatOfferConst';
import offerTypesConst from '@mixins/const/offerTypesConst';
import onboardingStepsConst from '@mixins/const/onboardingStepsConst';

export default {
  components: {
    AkButtonFooterSidebarFilter,
    AkInputText,
    AkDropdown,
    AkCalendar,
    MultiSelect,
  },
  mixins: [
    permissionsMixin,
    companyMixin,
    utilsMixin,
    sidebarMixin,
    accommodationTypeConst,
    residenceTypeConst,
    mandatOfferConst,
    ownerTypesConst,
    offerTypesConst,
    onboardingStepsConst,
  ],
  props: {
    modelValue: {required: true},
    callback: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      enabledStateConst: [
        {label: this.$t('all'), value: null},
        {label: this.$t('enabled_only'), value: true},
        {label: this.$t('disabled_only'), value: false},
      ],
      statusProspectConst: [
        {label: 'Nouveau', value: 'NOUVEAU'},
        {label: 'En cours', value: 'EN_COURS'},
        {label: 'Gagné', value: 'GAGNE'},
        {label: 'Perdu', value: 'PERDU'},
      ],
      loadingCommercial: true,
      commercials: [],
    };
  },
  mounted() {
    if (this.isGasGav())
      commercialService.commercials().then((data) => {
        this.commercials = data;
        this.commercials.push({id: undefined, display: '---'});
        this.loadingCommercial = false;
      });
  },
  methods: {
    itemSelect(item) {
      this.$nextTick(() => {
        this.callback[0]();
      });
    },
    search() {
      this.callback[0]();
      this.hideSidebar();
    },
    reset() {
      this.callback[1]();
      this.itemSelect();
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <form class="flex flex-col gap-4" @submit.prevent>
    <MultiSelect
      v-if="this.isGas()"
      v-model="currentValue.companyIds"
      :loading="this.loadingCompanies"
      :options="this.companies"
      :placeholder="$t('employee.company')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      option-label="name"
      option-value="id"
      @change="itemSelect" />
    <AkDropdown
      v-if="this.isGasGav()"
      v-model="currentValue.commercialId"
      :label="$t('onboarding.commercialId')"
      :loading="this.loadingCommercial"
      :options="this.commercials"
      inline
      option-label="display"
      option-value="id"
      @valueChange="itemSelect" />

    <AkInputText
      v-model="currentValue.ownerName"
      :inline="true"
      :placeholder="$t('interlocutor.prospect')"
      @valueChange="itemSelect" />
    <AkInputText
      v-model="currentValue.email"
      :inline="true"
      :placeholder="$t('contact.email')"
      @valueChange="itemSelect" />
    <AkInputText
      v-model="currentValue.phone"
      :inline="true"
      :placeholder="$t('contact.phone')"
      @valueChange="itemSelect" />
    <MultiSelect
      v-model="currentValue.ownerTypes"
      :options="ownerTypesConstFilter"
      :placeholder="$t('prospect.ownerType')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      inline
      option-label="label"
      option-value="value"
      @change="itemSelect" />

    <MultiSelect
      v-model="currentValue.currentOffer"
      :options="offerTypesConst"
      :placeholder="$t('prospect.formule')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      inline
      option-label="label"
      option-value="value"
      @change="itemSelect" />

    <AkCalendar
      v-model="currentValue.signupPeriod"
      :maxDate="new Date()"
      :placeholder="$t('prospect.signup')"
      selection="range"
      @valueChange="itemSelect" />
    <AkCalendar
      v-model="currentValue.lastActivityPeriod"
      :maxDate="new Date()"
      :placeholder="$t('prospect.lastActivity')"
      selection="range"
      @valueChange="itemSelect" />

    <MultiSelect
      v-model="currentValue.stepReached"
      :options="onboardingStepsConst"
      :placeholder="$t('prospect.stepReached')"
      class="form-control"
      filter
      filter-placeholder="Filtrer"
      inline
      option-label="label"
      option-value="value"
      @change="itemSelect" />

    <MultiSelect
      v-model="currentValue.statusProspect"
      :options="statusProspectConst"
      class="form-control"
      option-label="label"
      option-value="value"
      placeholder="Statut du prospect"
      @change="itemSelect" />

    <AkButtonFooterSidebarFilter validate-label="Rechercher" @action="search" @reset="this.reset" />
  </form>
</template>
